/**
 * Represents the source system for data import/synchronization.
 * Matches backend ImportSource enum
 */
export enum ImportSource {
  /**
   * Conversational Analytics.
   */
  CA = 0,

  /**
   * Virtual Agent.
   */
  VA = 1,
}
